import React from 'react';
import { useTranslation } from 'react-i18next';
import { Meta } from 'src/components/Meta';
import { useSession } from 'src/contexts/SessionContext';
import { AppFrameConfig } from 'src/shared/AppFrame/AppFrameConfig';
import EventsTable from 'src/shared/pageComponents/Events/EventsTable';

const EventsPage: React.FC = () => {
  const { session, user } = useSession();
  const { t } = useTranslation('translation', {
    keyPrefix: 'clients.eventsPage',
  });

  return (
    <>
      <AppFrameConfig
        id="events-page"
        containerMaxWidth={'xl'}
        title={t('events')}
      ></AppFrameConfig>
      <Meta title={t('events')} brand={session?.brand} />
      <EventsTable user={user} />
    </>
  );
};

export default EventsPage;
